import type { TQrExperienceActionType, TExperienceSocialPlatform } from '@shared/schemas';
import type {
	TBusinessCardExperienceContent,
	TSocialLinksExperienceContent,
} from '@shared/schemas';

export function getSuggestedQrName(
	content:
		| Pick<TBusinessCardExperienceContent, 'type' | 'fullName'>
		| Pick<TSocialLinksExperienceContent, 'type' | 'title'>
		| { type: 'menu'; restaurantName?: string }
		| { type: 'pdf'; title?: string }
		| { type: 'coupon'; company?: string; title?: string }
		| { type: 'app'; appName?: string },
	currentName: string | null | undefined,
): string {
	const current = currentName?.trim();
	if (current) return current.slice(0, 50);
	let suggested = '';
	if (content.type === 'business-card') {
		suggested = content.fullName ?? '';
	} else if (content.type === 'social-links' || content.type === 'pdf') {
		suggested = content.title ?? '';
	} else if (content.type === 'menu') {
		suggested = content.restaurantName ?? '';
	} else if (content.type === 'coupon') {
		suggested = content.title || content.company || '';
	} else if (content.type === 'app') {
		suggested = content.appName ? `${content.appName} App` : '';
	}
	return (suggested || 'QR Code').trim().slice(0, 50);
}

export function isRequiredQrNameValid(name: string): boolean {
	return name.trim().length > 0 && name.trim().length <= 50;
}

export function getExperienceActionLabel(
	actionType: TQrExperienceActionType,
	targetPlatform: TExperienceSocialPlatform | null,
	targetLabel?: string | null,
): string {
	switch (actionType) {
		case 'save-contact':
			return 'Saved Contact';
		case 'call':
			return 'Initiated Call';
		case 'email':
			return 'Sent Email';
		case 'open-map':
			return 'Opened Map Directions';
		case 'open-website':
			return 'Visited Website';
		case 'open-whatsapp':
			return 'Opened WhatsApp Chat';
		case 'view-pdf':
			return targetLabel && targetLabel.trim() ? targetLabel.trim() : 'Viewed PDF';
		case 'download-pdf':
			return targetLabel && targetLabel.trim() ? targetLabel.trim() : 'Downloaded PDF';
		case 'copy-coupon':
			return targetLabel && targetLabel.trim() ? targetLabel.trim() : 'Copied Promo Code';
		case 'download-app-ios':
			return targetLabel && targetLabel.trim() ? targetLabel.trim() : 'App Store (iOS)';
		case 'download-app-android':
			return targetLabel && targetLabel.trim() ? targetLabel.trim() : 'Google Play (Android)';
		case 'open-social':
			if (targetLabel && targetLabel.trim()) {
				return targetLabel.trim();
			}
			if (targetPlatform === 'custom') return 'Custom Link';
			return targetPlatform
				? `Opened ${targetPlatform.charAt(0).toUpperCase() + targetPlatform.slice(1)}`
				: 'Opened Social Link';
		default:
			return actionType;
	}
}
